import { BusinessPremises } from '@app/modules/business-premises/models/business-premises.model';
import { ErsVariant }       from '@app/modules/ers/models/ers.model';
import { Tss }              from '@app/modules/tss/models/tss.model';


// ENUMS #######################################################################
export enum RequestTssModalActionsEnum {
	ABORT = 'abort',
	CLOSE = 'close',
	DOWNLOAD_FCC_DATACENTER_API_KEY = 'downloadFccDatacenterApiKey',
	ERROR = 'error',
	FAIL = 'failed',
	OVERLAY_CONFIRMATION_DIALOGUE_HIDE = 'overlayConfirmationDialogueHide',
	OVERLAY_CONFIRMATION_DIALOGUE_SHOW = 'overlayConfirmationDialogueShow',
	OVERLAY_FCC_DATACENTER_API_KEY_HIDE = 'overlayFccDatacenterApiKeyHide',
	OVERLAY_FCC_DATACENTER_API_KEY_SHOW = 'overlayFccDatacenterApiKeyShow',
	REQUEST = 'request',
	SET_NAME = 'setName',
	SUCCESS = 'success',
}

export enum RequestTssModalModeEnum {
	BUSINESS_PREMISES = 'businessPremises',
	ERS = 'ers'
}

export enum RequestTssModalOverlayIdentifierEnum {
	CONFIRMATION_DIALOGUE = 'confirmationDialogue',
	FCC_DATACENTER_API_KEY = 'fccDatacenterApiKey'
}

export enum RequestTssModalTitleEnum {
	ON_USER_REQUEST = 'on_user_request',
	AFTER_CREATE = 'after_create',
}


// INTERFACES ##################################################################
export interface IRequestTssModalResultSet {
	action: RequestTssModalActionsEnum;
	bp?: BusinessPremises;
	ers?: ErsVariant;
	list?: BusinessPremises[] | ErsVariant[];
	tss?: Tss;
}
